export default __webpack_public_path__ + "static/media/DGAutoLtd.4201bb87.jpg";